module.exports = __webpack_public_path__ + "img/1F1F7-1F1F8.ce37b6da.svg";